import React, { createContext, useState, useEffect } from 'react';

import AdminApi from 'services/admin';
import { errHandling } from 'utils';

export const ProfileContext = createContext();

export default function ProfileContextProvider({ children }) {
  const [Profile, setProfile] = useState({});
  const [pageList, setPageList] = useState([]);
  const [orderCount, setOrderCount] = useState({});
  const [isProfileLoaded, setIsProfileLoaded] = useState(false);

  async function fetchProfile() {
    try {
      const {
        data: { data: ProfileData = {} },
      } = await AdminApi.getAdminMe();
      const {
        role: { permission: permissionsList = [] } = {},
        order_count: orderCountData,
      } = ProfileData;
      const pageListData = permissionsList.map((permission = {}) => {
        const { page } = permission;
        switch (page) {
          case 'users':
            permission.page = 'customers';
            break;
          case 'product_collections':
            permission.page = 'collections';
            break;
          case 'media':
            permission.page = 'media_products';
            break;
          default:
            break;
        }
        return permission;
      });

      setProfile(ProfileData);
      // TODO: change into setPageList(pageListData)
      setPageList([
        ...pageListData,
        { page: 'category-sections' },
        { page: 'customer-wallet' },
        { page: 'product-section' },
        { page: 'promo-section' },
        { page: 'rent-stocks' },
        { page: 'rent_exchange' },
        { page: 'fee' },
        { page: 'profile' },
        { page: 'order_exchange' },
        { page: 'order_refund' },
      ]);
      setOrderCount(orderCountData);
      setIsProfileLoaded(true);
      return;
    } catch (error) {
      errHandling(error);
    }
  }

  // Auto-fetch profile when user is authenticated
  useEffect(() => {
    const isAuthenticated = !!localStorage.getItem('cms_token');
    if (isAuthenticated) {
      fetchProfile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ProfileContext.Provider
      value={{ pageList, Profile, orderCount, fetchProfile, isProfileLoaded }}>
      {children}
    </ProfileContext.Provider>
  );
}
